
class DashboardRep{
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-rep.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardRep', new DashboardRep());

export default DashboardRep